import { Nullable } from 'cng-common/models/utils'

interface ICalculateYoYGrowthParams {
  currYearActualsRevenue: Nullable<number>
  prevYearActualsRevenue: Nullable<number>
}

export const calculateYoYGrowth = ({
  currYearActualsRevenue,
  prevYearActualsRevenue,
}: ICalculateYoYGrowthParams) => {
  if (!prevYearActualsRevenue || !currYearActualsRevenue) {
    return null
  }

  return (currYearActualsRevenue / prevYearActualsRevenue - 1) * 100
}
